import client from './client'

export interface AppConfig {
  company: {
    name: string
    legal_name: string
    address: string
    vat_number: string
    kbo_number: string
  }
  email: {
    info: string
    support: string
    registrations: string
    no_reply: string
  }
  fees: {
    percentage: number
    percentage_basis_points: number // canonical integer form; 200 = 2.00%
    fixed_cents: number
  }
  credits: {
    price_per_credit: number
    currency: string
  }
  features: {
    organiser_signups_enabled: boolean
  }
}

export async function fetchAppConfig(): Promise<AppConfig> {
  const response = await client.get<{ data: AppConfig }>('/public/app-config')
  return response.data.data
}
